<template>
  <v-select
    v-if="!$props.readonly"
    ref="vSelect"
    class="w-select--input"
    :class="{ 'w-select--input--has-label': $props.label }"
    v-bind="filterProps($props, ['label', 'items'])"
    :items="sortedItems"
    :label="computedLabel"
    :error-messages="errorMessages"
    outlined
    dense
    hide-details="auto"
    :menu-props="{ ...menuProps, 'offsetY': true }"
    v-on="$listeners"
    @focus="focus"
  >
    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-select>

  <w-read-only-text-field
    v-else
    :label="$props.label"
    :value="currentSelectionText"
    :inline-read-only="inlineReadOnly"
    :pending="pending"
  />
</template>

<script>
import get from 'lodash/get';
import { VSelect } from 'vuetify/lib';
import requireable from '@/mixins/component/requireable-mixin';
import pendingAble from '@/mixins/component/pending-able-mixin';
import sortedItems from '@/mixins/component/sorted-items-mixin';
import { filterProps } from '@/utils/functional-component-utils';

export default {
  mixins: [requireable, pendingAble, sortedItems],
  props: {
    inlineReadOnly: { type: Boolean, default: false },
    ...VSelect.options.props,
  },
  computed: {
    currentSelectionText() {
      var itemValue = this.itemValue || 'value';
      var itemText = this.itemText || 'text';

      if (this.multiple && this.items?.length && this.value) {
        let valueIds = [];
        this.value.forEach((v) => {
          valueIds.push(this.returnObject ? get(v, itemValue) : v);
        });
        return this.items
          .filter((i) => valueIds.includes(get(i, itemValue)))
          .map((i) => get(i, itemText))
          .join(', ');
      } else {
        var currentValue = this.returnObject
          ? get(this.value, itemValue)
          : this.value;
        var currentSelection = this.items.find(
          (i) => get(i, itemValue) == currentValue
        );
        return get(currentSelection, itemText) ?? this.findPlainValue();
      }
    },
  },
  methods: {
    filterProps: filterProps,
    focus() {
      this.$refs.vSelect.focus();
    },
    findPlainValue() {
      // e.g. items = ["A", "B", "C"], value = "A"
      return this.items.find((itemValue) => itemValue == this.value);
    },
    clear() {
      this.value = undefined;
      this.$emit('input', undefined);
    },
  },
};
</script>
<style lang="scss">
.w-select--input .v-input__append-inner {
  margin: auto;
}

.v-select__selections {
  padding: calc(#{$spacer} * 2) 0 #{$spacer} !important;

  .v-chip {
    margin: #{$spacer};
    background-color: $chips-bg-color;
    height: 24px;
  }

  .v-chip.v-size--default {
    font-size: 12px;
  }
}

.w-select--input--has-label {
  & > .v-input__control {
    padding-top: 0.25rem;
    .v-select__slot {
      // .v-label {
      //   font-size: 1rem !important;
      // }
      .v-input__append-inner {
        margin: auto;
      }
    }
  }
  .v-select__selection {
    font-size: 1rem;
  }
}
</style>
